import { useSyncExternalStore } from 'react';

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => undefined;
      const mq = window.matchMedia(query);
      mq.addEventListener('change', cb);
      return () => mq.removeEventListener('change', cb);
    },
    () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false),
    () => false,
  );
}

/** Phone layout breakpoint used across the app. */
export const PHONE_QUERY = '(max-width: 767px), (max-width: 1024px) and (max-height: 500px) and (pointer: coarse)';
export const useIsPhone = () => useMediaQuery(PHONE_QUERY);
